export default "__VITE_ASSET__BWQyzbQ5__"